import api from "@/lib/api";
import { WhatsappLogo, MegaphoneSimple } from "@phosphor-icons/react";
import { resolveMedia } from "@/lib/media";

export default function AdItem({ ad }) {
  const handleWhatsAppClick = async () => {
    try {
      const { data } = await api.post(`/ads/${ad.ad_id}/whatsapp-click`);
      window.open(data.whatsapp_link, "_blank");
    } catch {
      window.open(ad.whatsapp_link, "_blank");
    }
  };

  return (
    <div className="relative w-full h-full bg-black overflow-hidden">
      <img src={resolveMedia(ad.media_url)} alt={ad.title} className="absolute inset-0 w-full h-full object-cover opacity-95" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/95" />

      {/* Sponsored badge */}
      <div className="absolute top-4 left-4">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass text-[10px] uppercase tracking-[0.2em] font-bold text-white">
          <MegaphoneSimple size={14} weight="fill" className="text-blue-400" />
          Sponsored
        </div>
      </div>

      {/* Bottom content */}
      <div className="absolute bottom-0 left-0 right-0 p-6 pb-8 space-y-4">
        <h3 className="font-heading text-3xl font-black text-white leading-tight">{ad.title}</h3>
        {ad.description && (
          <p className="text-white/85 text-sm leading-relaxed max-w-md">{ad.description}</p>
        )}
        <button
          data-testid={`ad-whatsapp-${ad.ad_id}`}
          onClick={handleWhatsAppClick}
          className="w-full flex items-center justify-center gap-3 h-14 rounded-lg bg-[#25D366] hover:bg-[#1DA851] text-white font-heading font-bold text-lg transition-colors"
        >
          <WhatsappLogo size={24} weight="fill" />
          Chat with Advertiser
        </button>
      </div>
    </div>
  );
}
